import { useMemo } from 'react';

import type { Option } from '@packages/components/controls/controlled-select-v2/controlled-select-v2';
import { createOptions } from '@packages/utils/create-options/create-options';

export const useMaxConcurrentVulScansOptions = (): Option[] => {
  return useMemo(() => {
    const options: [string, string?][] = [['0', 'Unlimited']];
    const numberOptions: [string][] = Array.from({ length: 30 }, (_, i) => [
      `${i + 1}`,
    ]);
    options.push(...numberOptions);
    return createOptions(options);
  }, []);
};
